import { usePWA } from 'common/composition/usePWA.js'
import device from 'src/common/platform'

export default async () => {
  const PWA = usePWA()
  PWA.checkPWA()
  const isWebView = process.env.WEBVIEW === '1'
  const platform = process.env.PLATFORM
  const isIOSPlatform = device.is.ios

  if (process.env.NODE_ENV === 'development') {
    return
  }

  if ('serviceWorker' in navigator) {
    if (!isWebView && platform === 'olymp') {
      if (PWA.isPwa.value && isIOSPlatform) {
        const head = document.head

        const script1 = document.createElement('script')
        script1.text = 'window.PopMechanic = {watchLocation: false};'
        head.appendChild(script1)

        const script2 = document.createElement('script')
        script2.text = `
          mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
          mindbox.queue = mindbox.queue || [];
          mindbox('create', {
            endpointId: 'ec60563c-03c1-4b49-a676-2c3d3abb1dd6'
          });
          mindbox('webpush.create');
        `
        head.appendChild(script2)

        // 3. Подключение внешнего файла
        const script3 = document.createElement('script')
        script3.src = 'https://api.maestra.io/scripts/v1/tracker.js'
        script3.async = true
        head.appendChild(script3)
      } else {
        if (location.hostname === 'localhost') {
          return
        }
        navigator.serviceWorker
          .register('/ol-sw-mrr.js')
          .then((registration) => {
            // console.log('Service Worker зарегистрирован:', registration)
            // Проверяем наличие новой версии
            registration.onupdatefound = () => {
              const newWorker = registration.installing
              if (newWorker) {
                // console.log('Найден новый Service Worker:', newWorker)

                newWorker.onstatechange = () => {
                  if (newWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                      // console.log('Новая версия Service Worker готова.')

                      if (registration.waiting) {
                        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
                        // console.log('Отправлена команда SKIP_WAITING для нового Service Worker')
                      }
                    } else {
                      // console.log('Service Worker установлен впервые.')
                    }
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.error('Ошибка регистрации Service Worker:', error)
          })

        // Следим за изменением контроллера (новая версия SW)
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          // console.log('Service Worker обновился, можно перезагрузить страницу!')
          // location.reload()
        })
      }
    }

    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          if (registration.active && registration.active.scriptURL.endsWith('/service-worker.js')) {
            registration.unregister()
          }
        })
      })
      .catch((error) => {
        if (error?.name !== 'InvalidStateError') {
          console.error('Service Worker registrations read failed:', error)
        }
      })
  }
}
